(() => {
    const jobsFilter = document.querySelector('[data-jobs-filter]');
    const jobsList = document.querySelector('[data-jobs-list]');
    if (!jobsFilter || !jobsList) return;

    const FILTER_ALL = 'all';
    const cards = Array.from(jobsList.querySelectorAll('[data-job]'));
    const countEl = document.querySelector('[data-jobs-count]');
    const noMatch = document.querySelector('[data-jobs-nomatch]');
    const resetBtn = document.querySelector('[data-jobs-reset]');
    const buttons = Array.from(jobsFilter.querySelectorAll('[data-filter]'));
    const allBtn = buttons.find((b) => b.getAttribute('data-filter') === FILTER_ALL);
    const labelOne = countEl ? countEl.getAttribute('data-label-one') || '' : '';
    const labelMany = countEl ? countEl.getAttribute('data-label-many') || '' : '';

    const applyFilter = (filter) => {
        let visible = 0;
        cards.forEach((card) => {
            const tags = (card.getAttribute('data-tags') || '').split(' ').map((t) => t.replace(/^hash-/, '').replace(/^(lieu|contrat|niveau|temps|tt)-/, ''));
            const show = filter === FILTER_ALL || tags.indexOf(filter) !== -1;
            card.hidden = !show;
            if (show) visible += 1;
        });
        if (countEl) {
            countEl.textContent = visible + ' ' + (visible > 1 ? labelMany : labelOne);
        }
        if (noMatch) {
            noMatch.hidden = visible > 0;
        }
    };

    const selectFilter = (btn) => {
        buttons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        applyFilter(btn.getAttribute('data-filter'));
    };

    buttons.forEach((btn) => {
        btn.addEventListener('click', () => selectFilter(btn));
    });

    if (resetBtn && allBtn) {
        resetBtn.addEventListener('click', () => {
            selectFilter(allBtn);
            allBtn.focus();
        });
    }
})();

/* Offer page. The post body is written as one column: job description
   first, company presentation last. The profile block is moved after the
   first section and the last section is moved into the aside column. */
(() => {
    const content = document.querySelector('[data-offer-content]');
    const profile = document.querySelector('[data-offer-profile]');
    const aside = document.querySelector('[data-offer-structure]');
    if (!content || !profile || !aside) return;

    const headings = Array.from(content.querySelectorAll(':scope > h2'));
    if (headings.length < 2) return;

    content.insertBefore(profile, headings[1]);
    if (headings.length < 3) return;

    let node = headings[headings.length - 1];
    while (node) {
        const next = node.nextElementSibling;
        aside.appendChild(node);
        node = next;
    }
})();
